import { render, staticRenderFns } from "./PromotionsComponent.vue?vue&type=template&id=61d8977f&scoped=true"
import script from "./PromotionsComponent.vue?vue&type=script&lang=js"
export * from "./PromotionsComponent.vue?vue&type=script&lang=js"
import style0 from "./PromotionsComponent.vue?vue&type=style&index=0&id=61d8977f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8977f",
  null
  
)

export default component.exports